import { createSlice } from '@reduxjs/toolkit';

export const patientSlice = createSlice({
	name: 'patient',
	initialState: {
		id: '',
		firstName: '',
		lastName: '',
		tel: '',
		description: '',
		description_assistant: '',
		rest: {}
	},
	reducers: {
		setPatient: (state, action) => {
			const { firstName, lastName, tel, description, id, description_assistant } = action.payload;
			if (firstName || firstName === '') {
				state.firstName = firstName;
			}
			if (lastName || lastName === '') {
				state.lastName = lastName;
			}
			if (tel || tel === '') {
				state.tel = tel;
			}
			if (description || description === '') {
				state.description = description;
			}
			// description_assistant
			if (description_assistant || description_assistant === '') {
				state.description_assistant = description_assistant;
			}

			if (id || id === '') {
				state.id = id;
			}
		},
		cleanPatient: (state) => {
			state.tel = '';
			state.firstName = '';
			state.lastName = '';
			state.description = '';
			state.id = '';
		},
		setPatientFromAxios: (state, action) => {
			const {
				first_name: firstName,
				last_name: lastName,
				tel,
				description,
				id,
				national_id,
				description_assistant,
				...rest
			} = action.payload;
			if (firstName || firstName === '') {
				state.firstName = firstName;
			}
			if (lastName || lastName === '') {
				state.lastName = lastName;
			}
			if (tel || tel === '') {
				state.tel = tel;
			}
			if (description || description === '') {
				state.description = description;
			}
			if ((id && id.$oid) || id === '') {
				state.id = id.$oid;
			}
			if (national_id || national_id === '') {
				state.national_id = national_id;
			}
			if (description_assistant || description_assistant === '') {
				state.description_assistant = description_assistant;
			}
			state.rest = rest;
		}
	}
});

// Action creators are generated for each case reducer function
export const { setPatient, setPatientFromAxios, cleanPatient } = patientSlice.actions;

export default patientSlice.reducer;
